import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_QUESTIONNAIRES_LIST = 'GET_QUESTIONNAIRES_LIST';
export const GET_QUESTIONNAIRES_LIST_SUCCESS =
  'GET_QUESTIONNAIRES_LIST_SUCCESS';
export const GET_QUESTIONNAIRES_LIST_FAILURE =
  'GET_QUESTIONNAIRES_LIST_FAILURE';

// Action Creators
export const getQuestionnaireList = () => ({
  type: GET_QUESTIONNAIRES_LIST,
});

export const getQuestionnaireListSuccess = (users) => ({
  type: GET_QUESTIONNAIRES_LIST_SUCCESS,
  payload: users,
});

export const getQuestionnaireListFailure = (error) => ({
  type: GET_QUESTIONNAIRES_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getQuestionnaireListData = (external, pageCount) => {
  return async (dispatch) => {
    dispatch(getQuestionnaireList());
    try {
      const requestUrl =
        pageCount !== undefined
          ? `${url?.questionnaireList}?page=${pageCount}`
          : url?.questionnaireList;
      const response = await getMethodWithToken(requestUrl);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getQuestionnaireListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getQuestionnaireListFailure(error?.message));
    }
  };
};
